<template>
  <div class="sf-tab sf-tab-icons sf-full-width">
    <div class="sf-tab-item sf-block">
      <div class="sf-tab-item-icon">
        <span
          class="i-documents-file documents-document-icon sf-font-m sf-c-light"
        />
      </div>
      <div class="sf-grid sf-grid-fluid sf-grid-gutter-none">
        <div class="sf-row">
          <div class="sf-col sf-xs-12 sf-sm-8">
            {{ name }}
          </div>
          <div class="sf-col sf-xs-12 sf-sm-4">
            <div class="sf-progress sf-progress-animate sf-bg-snow">
              <div
                class="sf-progress-complete sf-bg-primary bar"
                :style="{ width: percentage }"
                data-testid="progress-container-bar"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

defineOptions({
  name: 'ProgressContainer',
})

interface Props {
  progress?: string | number
  name?: string
}

const props = withDefaults(defineProps<Props>(), {
  progress: 0,
  name: '',
})

const percentage = computed(() => `${props.progress}%`)
</script>
